<template>
  <v-row class="mt-3" v-if="lyra.commande_infos">
    <v-col cols="12">
      <div class="pa-4 rounded elevation-1 bg-darkblue">
        <div class="text-h6 text-center mb-3">Informations de paiement</div>
        <div class="d-flex justify-space-between w-100">
          <div>Identifiant du marchand</div>
          <div>{{ lyra.id_boutique }}</div>
        </div>
        <div class="d-flex justify-space-between w-100">
          <div>Réference de commande</div>
          <div>{{ lyra.commande_infos.orderId }}</div>
        </div>
        <div class="d-flex justify-space-between w-100">
          <div>Informations</div>
          <div>Inscription Sportips</div>
        </div>
        <div class="d-flex justify-space-between w-100">
          <div>Email associé</div>
          <div>{{ lyra.commande_infos.customer.email }}</div>
        </div>

        <div class="d-flex justify-space-between w-100 bg-grey_1 pa-3 mt-3 rounded">
          <div class="text-h6">Montant</div>
          <div class="text-h6 font-weight-bold">{{ amendBookingStore.cart.prix_total }}€</div>
        </div>
        <div class="d-flex justify-center mt-3">
          <img :src="require('../../../assets/img/lock.jpg')" alt="" class="rounded" />
        </div>
        <div class="text-center mt-2">Ce symbole indique que vous pouvez effectuer votre transaction en toute sécurité
        </div>
        <CheckoutForm class="mt-3" v-if="lyra.endpoint" :lyra="lyra"></CheckoutForm>
        <div v-else class="d-flex justify-center mt-3">
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </div>
        <div class="d-flex justify-center mb-3">
          <img class="logo_paiement" src="https://sportips.fr/images/logo_securise.png" alt="" />
        </div>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import { mapStores } from "pinia";
import { useAmendBookingStore } from "@/stores/amendBookingStore";
import { useMainStore } from "@/stores/mainStore";
import CheckoutForm from "@/components/Checkout/Checkout_Form.vue";
import Lyra_Payment from "@/classes/Payment/Lyra_Payment.class";
export default {
  components: {
    CheckoutForm,
  },
  data() {
    return {
      lyra: {},
    };
  },
  computed: {
    ...mapStores(useAmendBookingStore, useMainStore),
  },
  methods: {
    async postData() {
      const post_request = await this.amendBookingStore.post_default_checkout();
      if (post_request) {
        this.$emit("onError", "Une erreur est survenue lors de la validation de votre commande.");
        return;
      }
    },
    initLyraPayment() {
      this.lyra = new Lyra_Payment();
      this.lyra.set_commande_infos(this.amendBookingStore.uuid, this.amendBookingStore.cart.prix_total, this.mainStore.authUser.userMail, this.amendBookingStore.cart);
      this.lyra.init_amend_options();
    }
  },
  async mounted() {
    if (!this.amendBookingStore.uuid) {
      this.$router.push({ name: "FicheCoureur" });
    }
    await this.postData();
    await this.initLyraPayment();
  },
};
</script>

<style lang="scss" scoped>
.logo_paiement {
  width: 150px;
  max-width: 100%;
  height: auto;
}
</style>